var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group mb-3 row"},[_c('div',{staticClass:"col-sm-3"},[_c('label',{class:{ required:_vm.required }},[_vm._v(_vm._s(_vm.label)+":")])]),_c('div',{staticClass:"col-sm-9"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }